/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React, { ChangeEvent, useEffect, useState } from 'react';

interface Props {
  handleVolume: (arg?: number) => Promise<number>;
  handleMute: (arg: boolean) => void;
  isMuted: boolean;
}

export default function VolumeController({ handleVolume, handleMute, isMuted }: Props): JSX.Element {
  const [value, setValue] = useState(0);
  const [showVolume, setShowVolume] = useState(false);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(Number(e.target.value));
    handleVolume(Number(e.target.value) / 100);
  };

  useEffect(() => {
    async function setVolume() {
      const volume = await handleVolume();
      setValue(volume * 100);
    }
    if (isMuted) {
      setValue(0);
    } else {
      setVolume();
    }
  }, [handleVolume, isMuted]);

  return (
    <a className="transport-control volume">
      <div
        className={`transport-control volume volume-container ${showVolume ? 'active' : ''}`}
        onMouseEnter={() => setShowVolume(true)}
        onMouseLeave={() => setShowVolume(false)}
        id="VolumeController"
      >
        <div className="volume-controller" style={{ display: showVolume ? 'block' : 'none' }}>
          <input
            type="range"
            min="0"
            max="100"
            className="slider"
            onChange={handleChange}
            value={value}
            id="VolumeController_inputRange"
          />
          <div className="triangle-element">
            <div
              className="clip-path"
              style={{
                width: `${value}%`,
              }}
            />
            <div className="clip-path-background" />
          </div>
        </div>
        <div
          className={`volume-button ${isMuted ? 'muted' : ''}`}
          onClick={() => handleMute(!isMuted)}
          id="VolumeController_muteButton"
        />
      </div>
    </a>
  );
}
